const WORDS = [
  "Pesce fresco",
  "Trofie al pesto",
  "Aperitivi vista mare",
  "Gelati artigianali",
  "Colazioni al banco",
  "Cucina ligure",
];

export default function Ribbon() {
  return (
    <div
      data-testid="specialties-ribbon"
      className="bg-terracotta text-bone py-4 sm:py-5 px-5 select-none"
    >
      <div className="mx-auto max-w-[1400px] flex flex-wrap items-center justify-center gap-x-5 gap-y-2 sm:gap-x-7">
        {WORDS.map((w, i) => (
          <span key={w} className="flex items-center gap-x-5 sm:gap-x-7">
            <span className="font-serif italic text-lg sm:text-2xl whitespace-nowrap">{w}</span>
            {i < WORDS.length - 1 && (
              <span aria-hidden="true" className="text-bone/60 text-base sm:text-lg">
                ✦
              </span>
            )}
          </span>
        ))}
      </div>
    </div>
  );
}
